
// src/components/ClipboardButton.js
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight, Check } from "lucide-react";

const ClipboardButton = ({ email, buttonText }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async () => {
    if (isCopied) return; // Prevent multiple rapid clicks

    try {
      await navigator.clipboard.writeText(email);
      setIsCopied(true);
      // Reset the button state after 3 seconds
      setTimeout(() => {
        setIsCopied(false);
      }, 3000);
    } catch (err) {
      console.error("Failed to copy text: ", err);
      // You could add error feedback here if needed
    }
  };

  return (
    <div className="flex flex-col items-center">
      <motion.button
        onClick={handleCopy}
        className="group inline-flex items-center justify-center gap-3 bg-white text-black px-8 py-3 rounded-full font-bold text-sm uppercase tracking-widest transition-all duration-300 w-64 overflow-hidden"
        animate={isCopied ? { backgroundColor: "#10B981" } : { backgroundColor: "#FFFFFF" }}
      >
        <AnimatePresence mode="wait">
          {!isCopied ? (
            <motion.span
              key="default"
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -20, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="flex items-center gap-3"
            >
              {buttonText}
              <ArrowRight
                size={16}
                className="transition-transform group-hover:translate-x-1"
              />
            </motion.span>
          ) : (
            <motion.span
              key="copied"
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -20, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="flex items-center gap-3 text-white"
            >
              Copied to Clipboard
              <Check size={16} />
            </motion.span>
          )}
        </AnimatePresence>
      </motion.button>

      <p className="text-xs text-gray-500 mt-4">
        Or manually copy: <span className="font-semibold text-gray-400">{email}</span>
      </p>
    </div>
  );
};

export default ClipboardButton;